import { GraphQLErrorEnvelope } from "@/lib/graphql-error-envelope";

const CONFLICT_STATUS_CODE: number = 409;

export function isMunicipalPropertyConsumptionConflict(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const errorList: NonNullable<GraphQLErrorEnvelope["response"]>["errors"] = (error as GraphQLErrorEnvelope).response?.errors;
  return (
    errorList?.some(
      ({ extensions }: NonNullable<NonNullable<GraphQLErrorEnvelope["response"]>["errors"]>[number]): boolean =>
        extensions?.originalError?.statusCode === CONFLICT_STATUS_CODE,
    ) ?? false
  );
}
